import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { isWithinInterval, subYears } from 'date-fns'

import { BIRTHDATE_FORMAT } from 'constants/user'

const getBirthDate = diff => subYears(new Date(), diff)

const toUSFormat = date => {
  if (!date) {
    return date
  }

  const [year, month, day] = date.split('-')
  return `${month}-${day}-${year}`
}
const fromUSFormat = date => {
  if (!date) {
    return date
  }

  const [month, day, year] = date.split('-')
  return `${year}-${month}-${day}`
}

const addDashSuffix = date => {
  const numberOfDashes = date.split('-').length - 1
  return (date.length === 2 && numberOfDashes === 0) || (date.length === 5 && numberOfDashes === 1)
}

const FORMAT = toUSFormat(BIRTHDATE_FORMAT)

const MIN_AGE = 18
const MAX_AGE = 100

const datePattern = /^(\d{2})-(\d{2})-(\d{4})$/

const minDate = getBirthDate(MAX_AGE)
const maxDate = getBirthDate(MIN_AGE)

const BirthdateInput = ({ Input, name, classNames, onChange, value, ...rest }) => {
  const [date, setDate] = useState(toUSFormat(value) || '')

  const handleChange = useCallback(
    e => {
      const newValue = e.target.value
      const value =
        date.length < newValue.length && addDashSuffix(newValue) ? newValue + '-' : newValue
      setDate(value)

      const showError = error => {
        e.target.setCustomValidity(error)
        e.target.checkValidity(e)

        onChange({
          target: {
            name,
            value: '',
          },
        })
      }

      if (!datePattern.test(value)) {
        return showError(`Enter a date in the format ${FORMAT.toUpperCase()}`)
      }

      const dateObject = new Date(fromUSFormat(value))
      console.log('xxxx yyyy sss zz', dateObject, fromUSFormat(value))
      if (isNaN(dateObject.getTime())) {
        return showError('Invalid date provided')
      }

      const isValid = isWithinInterval(dateObject, {
        start: minDate,
        end: maxDate,
      })

      if (!isValid) {
        return showError('You must be 18+ to continue')
      }

      e.target.setCustomValidity('')
      onChange({
        target: {
          name,
          value: fromUSFormat(value),
        },
      })
    },
    [date, name, onChange]
  )

  return (
    <Input
      type="text"
      inputmode="numeric"
      pattern="^[0-9-]+$"
      name={name}
      classNames={{ input: 'inverted-calendar-picker', ...classNames }}
      onChange={handleChange}
      {...rest}
      placeholder={FORMAT.toUpperCase()}
      value={date}
    />
  )
}

BirthdateInput.defaultProps = {
  classNames: {},
}

BirthdateInput.propTypes = {
  classNames: PropTypes.object,
}

export default BirthdateInput
